import * as React from "react";
import { RouteComponentProps } from "@reach/router";
import { Classes } from "../classes/Classes";

export class ClassesScreen extends React.PureComponent<RouteComponentProps> {
  render() {
    return <Classes />;
  }
}
